import { makeStyles } from "@material-ui/core/styles";
import { blue900, lightGray } from "../../../../components/common/PL/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(4),
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  title: {
    color: blue900,
    fontWeight: 600,
  },
  count: {
    color: "#8A8D96",
    fontSize: "0.9rem",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  state: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  stateText: {
    color: lightGray,
    fontSize: "0.9rem",
    textAlign: "center",
  },
}));

export default useStyles;
